const LOCAL_HOSTS = ['localhost', '127.0.0.1'];
const isLocalDevelopment =
  typeof window !== 'undefined' && LOCAL_HOSTS.includes(window.location.hostname);

const API_URL = isLocalDevelopment
  ? 'http://localhost:8001'
  : process.env.REACT_APP_BACKEND_URL;

const requestJson = async (path, token, options = {}) => {
  const response = await fetch(`${API_URL}/api/legal-operations${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  const body = await response.text();
  let data = {};
  try {
    data = body ? JSON.parse(body) : {};
  } catch (error) {
    throw new Error('استجابة خدمة التشغيل القانوني غير صالحة.');
  }
  if (!response.ok) {
    throw new Error(typeof data.detail === 'string' ? data.detail : 'تعذر تنفيذ الطلب التشغيلي.');
  }
  return data;
};

const requestPublicJson = async (path, options = {}) => {
  const response = await fetch(`${API_URL}/api/legal-operations${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const body = await response.text();
  let data = {};
  try {
    data = body ? JSON.parse(body) : {};
  } catch (error) {
    throw new Error('استجابة خدمة الرسائل غير صالحة.');
  }
  if (!response.ok) {
    throw new Error(typeof data.detail === 'string' ? data.detail : 'تعذر إرسال الرسالة.');
  }
  return data;
};

export const legalOperationsService = {
  sendIncomingMessage(payload) {
    return requestPublicJson('/messages/incoming', { method: 'POST', body: JSON.stringify(payload) });
  },
  getMessageSummary(token) {
    return requestJson('/messages/summary', token);
  },
  getMessages(token) {
    return requestJson('/messages', token);
  },
  getMessageConversation(token, conversationId) {
    return requestJson(`/messages/${conversationId}`, token);
  },
  replyToMessage(token, conversationId, message) {
    return requestJson(`/messages/${conversationId}/reply`, token, {
      method: 'POST',
      body: JSON.stringify({ message }),
    });
  },
  getMetadata(token) {
    return requestJson('/meta', token);
  },
  seedRoles(token) {
    return requestJson('/roles/seed', token, { method: 'POST' });
  },
  getUsers(token) {
    return requestJson('/users', token);
  },
  createUser(token, payload) {
    return requestJson('/users', token, { method: 'POST', body: JSON.stringify(payload) });
  },
  updateUser(token, userId, payload) {
    return requestJson(`/users/${userId}`, token, { method: 'PATCH', body: JSON.stringify(payload) });
  },
  assignRole(token, userId, roleId) {
    return requestJson(`/users/${userId}/role`, token, { method: 'PUT', body: JSON.stringify({ role_id: roleId }) });
  },
  deleteUser(token, userId) {
    return requestJson(`/users/${userId}`, token, { method: 'DELETE' });
  },
  resetUserPassword(token, userId, newPassword) {
    return requestJson(`/users/${userId}/password`, token, { method: 'PATCH', body: JSON.stringify({ new_password: newPassword }) });
  },
  createPerformanceReview(token, userId, payload) {
    return requestJson(`/users/${userId}/performance-reviews`, token, { method: 'POST', body: JSON.stringify(payload) });
  },
  getCases(token) {
    return requestJson('/cases', token);
  },
  createCase(token, payload) {
    return requestJson('/cases', token, { method: 'POST', body: JSON.stringify(payload) });
  },
  getCase(token, caseId) {
    return requestJson(`/cases/${caseId}`, token);
  },
  getTimeline(token, caseId) {
    return requestJson(`/cases/${caseId}/timeline`, token);
  },
  requestAIAnalysis(token, caseId, requestedOutputs) {
    return requestJson(`/cases/${caseId}/ai-analysis`, token, {
      method: 'POST',
      body: JSON.stringify(requestedOutputs ? { requested_outputs: requestedOutputs } : {}),
    });
  },
  getActivity(token) {
    return requestJson('/activity', token);
  },
};
